// Full-document render of the Oscar basket view: PageSkeleton (the React
// document shell) wrapping the `#basket-app` mount point.
import React from "react";

import { templates } from "@reactivated";

import { BasketPageBody } from "../components/BasketPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.BasketDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <BasketPageBody />
        </PageSkeleton>
    );
};
